import get from 'lodash/get';

import {
  destinationTypeCustomHtml,
  destinationTypeEmail,
  destinationTypeFacebookConversion,
  destinationTypeGoogleConversion,
  destinationTypeSalesforce,
  destinationTypeSlack,
  destinationTypeWebhook,
} from '~/lib/destinations';
import { readableSegmentType } from '~/lib/segments';

export function slackChannelName(channelId, users = [], channels = []) {
  const recipient = [...users, ...channels].find(
    (channel) => channel.id === channelId,
  );
  const isChannel = channelId[0] === 'C';
  if (!recipient) return `An unknown ${isChannel ? 'channel' : 'user'}`;
  if (isChannel) return `#${recipient.name}`;
  return `@${recipient.profile.displayName}`;
}

export const description = (destination, slackAccountConnector) => {
  const { config = {}, type } = destination;

  if (type === destinationTypeCustomHtml) {
    return (
      <>
        Will render your <strong>custom HTML</strong>
      </>
    );
  } else if (type === destinationTypeEmail) {
    const recipients = config.recipients || [];
    const recipientsText =
      recipients.length > 1 ? `${recipients.length} recipients` : recipients;

    return (
      <>
        Will deliver <strong>{config.frequency}</strong> to{' '}
        {<strong>{recipientsText}</strong>}
      </>
    );
  } else if (type === destinationTypeFacebookConversion) {
    return <>Will send event to Facebook</>;
  } else if (type === destinationTypeGoogleConversion) {
    return <>Will send conversion to Google Ads</>;
  } else if (type === destinationTypeWebhook) {
    return <>Will deliver to {<strong>{config.url}</strong>}</>;
  } else if (type === destinationTypeSalesforce) {
    return (
      <>
        Will{' '}
        {get(config, 'object') === 'chatter' ? (
          <>
            post a message to <strong>Salesforce chatter</strong>
          </>
        ) : (
          <>
            <strong>create a new task</strong> in Salesforce
          </>
        )}
      </>
    );
  } else if (type === destinationTypeSlack) {
    const { config: { channels, webhookUrl } = {} } = destination;

    if (channels) {
      if (!slackAccountConnector) return ' ';

      const {
        remoteMeta: { channels: slackChannels, users: slackUsers } = {},
      } = slackAccountConnector;

      const firstChannel = channels[0];

      return (
        <>
          Will post a message to{' '}
          <strong>
            {slackChannelName(firstChannel, slackUsers, slackChannels)}
          </strong>
          {channels.length > 1 && (
            <>
              {' '}
              and{' '}
              <strong>
                {channels.length - 1} other channel
                {channels.length > 2 ? 's' : ''}
              </strong>
            </>
          )}
        </>
      );
    }

    return (
      <>
        Will post a message to <strong>{webhookUrl}</strong>
      </>
    );
  } else {
    return destination.description;
  }
};

const SECONDS = {
  months: 2592000,
  weeks: 604800,
  days: 86400,
};

export function timePeriod(exclusionTimeframe, segmentType) {
  if (!exclusionTimeframe || exclusionTimeframe === 0) return '';

  let result;
  let divisor;

  for (let key in SECONDS) {
    divisor = exclusionTimeframe / SECONDS[key];

    if (divisor === 1) {
      key = key.substring(0, key.length - 1);
    }

    if (Number.isInteger(divisor) && divisor >= 1) {
      result = `${divisor} ${key}`;
      break;
    }
  }

  if (!result) return '';

  return (
    <>
      - Excludes {readableSegmentType(segmentType)} delivered in the last{' '}
      <strong>{result}</strong>
    </>
  );
}
